export const ACTIONS_ELECTION = {
	ELECTION: 'election_view',
	ELECTION_CREATE: 'election_create',
	ELECTION_ADD: 'election_add',
	ELECTION_EDIT: 'election_edit',
	ELECTION_DELETE: 'election_delete',
	ELECTION_SEARCH: 'election_search',
	ELECTION_FILTER: 'election_filter',
} as const;
